import msa from "./contracts/msa.md?raw";
import sowDigitalAi from "./contracts/sow-digital-ai.md?raw";

/** @typedef {{ slug: string; title: string; summary: string; body: string }} ContractDoc */

/** @type {ContractDoc[]} */
export const contractDocuments = [
  {
    slug: "msa",
    title: "Master Services Agreement (draft)",
    summary:
      "General commercial scaffolding for Statements of Work, confidentiality, acceptance, billing, limitation of liability placeholders, termination, dispute venue.",
    body: msa,
  },
  {
    slug: "sow-digital-ai",
    title: "Statement of Work - Digital & AI Implementation (draft)",
    summary:
      "Broad SOW spanning AI reception workflows, grounded chat/RAG, optional network readiness, and web launch surfaces under one Exhibit.",
    body: sowDigitalAi,
  },
];

export function getContractBySlug(slug) {
  return contractDocuments.find((c) => c.slug === slug) ?? null;
}

export function contractSlugs() {
  return contractDocuments.map((c) => c.slug);
}
